var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item',{staticClass:"pr-1",on:{"click":_vm.itemClick}},[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(_vm.title))])],1),(_vm.to)?_c('v-list-item-icon',[_c('v-icon',[_vm._v(_vm._s(_vm.icon))])],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }